import { getSystemModules } from '@/composables/currentUser'


export const routeIsAvailable = route => {
  const systemModules = getSystemModules()
  return systemModules.includes(route)
}
